import SearchFormContainer from './SearchFormContainer';

export default SearchFormContainer;
